export class ResponseModel{
    StatusCode:number;
    Message:string;
    Success:boolean;
    Data:any;

    constructor(success, statusCode, message, data?){
        this.Success = success;
        this.StatusCode = statusCode;
        this.Message = message;
        this.Data = data;
    }
}